<template>
  <div
    v-if="!loading && programs.length"
    id="list">
    <div
      class="has-background-white is-radius is-bordered is-margin-bottom"
      :class="{'has-status-bar--left has-status-bar--draft': lastOpenedItemPk === program.pk}"
      v-for="(program, i) in programs"
      :key="program.pk + i"
      :id="'e' + program.pk">
      <program-card
        :program="program"
        :source-programs="programs"
        :source-lots="sourceLots"
        @deleteProgram="deleteProgram"></program-card>
    </div>
  </div>
</template>

<script>
import StockMixin from './StockMixin'
import ProgramListMixin from './ProgramListMixin'
import ProgramCrudMixin from '@/components/programs/ProgramCrudMixin'

export default {
  name: 'ProgramCardList',
  components: {
    ProgramCard: () => import('./ProgramCard')
  },
  mixins: [
    StockMixin,
    ProgramListMixin,
    ProgramCrudMixin
  ]
}
</script>
